import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import fetcher, {
    fetcherFull,
    MethodEnum,
} from 'utils/helpers/browser/newFetcher';
import { FormResponseData } from 'services/user.service';
import { CoachLicenceTypeApiInterface } from 'submodules/api_middleware';

export class CoachService {
    getList = async (query: NextApiRequestQuery): Promise<FormResponseData> => {
        return await fetcher(`/api/coaches/list`, MethodEnum.GET, query);
    };

    getLicenceTypes = async (): Promise<
        FormResponseData & { data?: CoachLicenceTypeApiInterface[] }
    > => {
        return await fetcherFull<
            FormResponseData & { data?: CoachLicenceTypeApiInterface[] }
        >(`/api/coaches/license-types`, MethodEnum.GET);
    };
}
